// Time before loading new necord in multimodal
export const SECONDS_BEFORE_RECORD_LOADING = 300;
